<template>
  <v-app>
    <v-container>
      <router-view></router-view>
    </v-container>
  </v-app>
</template>

<script>
import Container from './components/Container'

export default {
  name: 'App',
  components: {
    'v-container': Container
  },
  data () {
    return {
      //
    }
  },
  created: function () {
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch('logout')
        }
        throw err
      })
    })
  }
}
</script>

<style lang="scss">
  .v-application a {
    text-decoration: none;
    color: #333;
  }

  .swal2-container {
    font-family: Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

</style>
